import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DashboardService } from '../dashboard/dashboard.service';
import { S3Service } from '../services/s3.service';
import { ProfileService } from './profile.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SharedService } from '../services/shared.service';
import * as _ from 'lodash';
import { ChangePasswordComponent } from '../change-password/change-password.component';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  showEdit = false;
  profileForm: FormGroup;
  setColor: string = '';
  setBTColor: string = '#FF6900';
  logo: File;
  logoBase64 = "";
  selectedBTColor = "#FF6900";
  colors = ['#FF6900', '#FCB900', '#7BDCB5', '#00D084', '#8ED1FC', 
            '#0693E3', '#ABB8C3', '#EB144C', '#F78DA7', '#9900EF', '#D0021B', 
            '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', 
            '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', 
            '#9B9B9B', '#FFFFFF', '#B80000', '#DB3E00', '#FCCB00', '#008B02',
            '#006B76', '#1273DE', '#004DCF', '#5300EB', '#EB9694', '#FAD0C3',
            '#FEF3BD', '#C1E1C5', '#BEDADC', '#C4DEF6', '#BED3F3', '#D4C4FB'];
	bgTextColor = "#000000";
  disableUpdate: Boolean = true;
  activeOrgs: any = [];
  organizations: any = [];
  org_id: any = localStorage.getItem("organization")

  constructor(
    private _dataSerivce: DashboardService,
    private _fb: FormBuilder,
    private _s3Service: S3Service,
    private _profileService: ProfileService,
    private _snackBar: MatSnackBar,
    private _sharedService: SharedService,
    public dialog: MatDialog
  ) {
    if (localStorage.getItem('bgColor')) this.setColor = localStorage.getItem('bgColor');
    // let logoKey = localStorage.getItem('organizationLogo');
    // if (logoKey && logoKey.length > 0) this.fetchFileFromS3(logoKey);
  }

  ngOnInit(): void {
    this.onInit(); 
  }

  onInit(): void {
    if (localStorage.getItem('bgTextColor')) this.bgTextColor = localStorage.getItem("bgTextColor");
    this.profileForm = this._fb.group({
      firstName: [this.userNameToUpperCase(localStorage.getItem('firstName')), Validators.required],
      lastName: [this.userNameToUpperCase(localStorage.getItem('lastName')), Validators.required],
      organizationName: [localStorage.getItem('organizationName'), Validators.required],
      location: [localStorage.getItem('organizationAddress'), Validators.required],
      organizationLogo: [],
      sort_id: [localStorage.getItem('organizationCode')],
      organizations: this._fb.array([])
    });

    

    this._sharedService.getUserDetails().subscribe((response: any) => {
      if(response['success']) {
        this.profileForm = this._fb.group({
          firstName: [this.userNameToUpperCase(response['user']['firstName']), Validators.required],
          lastName: [this.userNameToUpperCase(response['user']['lastName']), Validators.required],
          organizationName: [response['user']['organizationName'], Validators.required],
          location: ['', Validators.required],
          organizationLogo: [],
          sort_id: [response['user']['organizationCode']],
          organizations: this._fb.array([])
        });
        if(response['user'] && response['user']['address'] && response['user']['address']['state']) {
          this.profileForm.controls['location'].setValue(response['user']['address']['state']);
        }
        if(response?.user?.organizations?.length) {
          this.organizations = response.user.organizations
          this.filterActiveOrgs(response.user.organizations)
          for(let org of response.user.organizations) {
            this.prepareOrganizationForm(org);
          }
        }
        this.fetchFileFromS3(response['user']['organizationLogo'])
        if (this.logoBase64.length > 0) { this.profileForm.controls['organizationLogo'].patchValue(this.logoBase64); }

      }
    })

  }

  filterActiveOrgs(organizations: any) {
    this.activeOrgs = _.filter(organizations, (org) => {
      return org.team_status == true;
    })
  }

  fetchFileFromS3(key) {
    if (key.length > 0) {
      this._s3Service.getObjectFromKey(key).subscribe((response) => {
        var binary = '';
        var bytes = new Uint16Array(response['data']);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        this.profileForm.controls['organizationLogo'].patchValue(window.btoa(binary));
        let logo = "data:image/jpeg;base64," + this.profileForm.controls['organizationLogo'].value;
        this.logoBase64 = logo;
        this.profileForm.controls['organizationLogo'].patchValue(logo);
      }, (error) => {
        console.log(error);

      });
    }
  }

  userNameToUpperCase(text) {
    return text.toLowerCase().split(' ').map((i, j) => i.charAt(0).toUpperCase() + i.slice(1)).join(' ');
  }

  onFileChange(event) {
    let file = event.target.files[0];
    this.logo = file;
    let reader = new FileReader();
    reader.onload = (evt) => {
      // let logo = "data:image/jpeg;base64," + window.btoa(file);
      this.profileForm.controls['organizationLogo'].patchValue(evt.target.result);
    }
    reader.readAsDataURL(file);
    this.disableUpdate = false;
  }

  setBgColor(clr) {
    this.setColor = clr;
  }

  applyColor() {
    if (this.setColor) this._dataSerivce.setBgColor({ color: this.setColor, type: "bgColor" });

    const formData: FormData = new FormData();
    var data = {
      theme: {
        bg_color: this.setColor
      },
      email: localStorage.getItem('email')
    };
    formData.append('data', JSON.stringify(data));
    this._profileService.updateUser(formData).subscribe(
      (response) => {
        if (response['success']) {
          // if (localStorage.getItem('email')) {
          // 	this._router.navigateByUrl('/dashboard');
          // }
          // this.successMsg = true;

          //this._dataSerivce.setBgColor(this.setColor);
          localStorage.setItem('bgColor', this.setColor);
          this.openSnackBar(response["message"]);
        }
      },
      err => {
        console.log(err);
        // this.successMsg = false;
      });
  }

  updateData() {
    let formValue = this.profileForm.getRawValue();
    let organizationName = this.profileForm.controls['organizationName'].value;
    let organizationState = this.profileForm.controls['location'].value;
    let firstName = this.profileForm.controls['firstName'].value;
    let lastName = this.profileForm.controls['lastName'].value;
    let orgnizations = formValue['organizations'];
    const { sort_id } = formValue;

    if (organizationName.length === 0 || organizationState.length === 0 || firstName.length === 0 || lastName.length === 0) {
      this.disableUpdate = true;
      return;
    }
    localStorage.setItem('organizationName', organizationName);
    localStorage.setItem('firstName', firstName)
    localStorage.setItem('lastName', lastName)
    localStorage.setItem('organizationAddress', organizationState);
    const formData: FormData = new FormData();
    formData.append('name', organizationName);
    formData.append('firstName', firstName);
    formData.append('lastName', lastName);
    formData.append('userId', localStorage.getItem('userId'));
    formData.append('address', JSON.stringify({ state: organizationState }));
    formData.append('organizationId', localStorage.getItem('organization'));
    formData.append('isProfileUpdate', 'true');
    formData.append('organizations', JSON.stringify(orgnizations))
    formData.append('code', sort_id);
    if (this.logo) {
      formData.append('logo', this.logo);
    }

    this._profileService.updateOrganization(formData).subscribe(
      (response) => {
        if (response['success'] && response['data']) {
          const logoKey = response['data']['logo'];
          if (logoKey && logoKey.length > 0) {
            localStorage.setItem('organizationLogo', logoKey);
            this.fetchFileFromS3(logoKey);
          }

          localStorage.setItem('organizationAddress', organizationState);
          localStorage.setItem("organizationCode", sort_id);
          this._profileService.updateHeader(response['data']);
          this.openSnackBar("Profile updated successfully");
          this.disableUpdate = true;
          this.showEdit = false;
        }
      },
      err => {
        console.log(err);
        // this.successMsg = false;
      });


    // if (localStorage.getItem('firstName') !== firstName || localStorage.getItem('lastName') !== lastName) {

    //   const formData: FormData = new FormData();
    //   var data = {
    //     firstName: this.profileForm.controls['firstName'].value,
    //     lastName: this.profileForm.controls['lastName'].value,
    //     email: localStorage.getItem('email')
    //   };
    //   formData.append('data', JSON.stringify(data));
    //   this._profileService.updateUser(formData).subscribe(
    //     (response) => {
    //       if (response['success']) {
    //         localStorage.setItem('firstName', data.firstName);
    //         localStorage.setItem('lastName', data.lastName);
    //         this._profileService.updateHeader(response);
    //       }
    //     },
    //     err => {
    //       console.log(err);
    //       // this.successMsg = false;
    //     });
    // }

  }

  applyBackgroundTextColor(): void {
    if (this.setBTColor !== "") {
      if (this.setBTColor) this._dataSerivce.setBgColor({ color: this.setBTColor, type: "bgTextColor"});

      const formData: FormData = new FormData();
      var data = {
        theme: {
          bg_text_color: this.setBTColor
        },
        email: localStorage.getItem('email')
      };
      formData.append('data', JSON.stringify(data));
      this._profileService.updateUser(formData).subscribe(
        (response) => {
          if (response['success']) {
            localStorage.setItem('bgTextColor', this.setBTColor);
            this.bgTextColor = this.setBTColor;
            this.openSnackBar(response["message"]);
          }
        }, err => {
          console.log(err);
        });
    }
  }

  openSnackBar(message) {
    this._snackBar.open(message, "Ok", {
      duration: 2000
    });
  }

  cancelUpdate() {
    this.showEdit = !this.showEdit;
    this.disableUpdate = true;
    this.onInit();
  }

  get organizationForms(): any {
    return this.profileForm.get('organizations') as FormArray;
  }

  prepareOrganizationForm(org): void {
    let org_form: FormGroup = this._fb.group({
      name: new FormControl(org.name),
      team_status: new FormControl(org.team_status),
      org_id: new FormControl(org._id)
    })
    if(this.org_id == org._id) {
      org_form.controls['team_status'].disable()
    }
    if(this.activeOrgs.length == 1 && this.activeOrgs[0]['org_id'] == org._id) {
      org_form.controls['team_status'].disable()
    }
    this.organizationForms.push(org_form)
  }

  onStatusToggleChange(event: any): void {
    let formValue = this.profileForm.getRawValue();
    let orgs = formValue['organizations'];
    this.filterActiveOrgs(orgs);

    this.disableUpdate = false;
    let orgFormArray: any = this.profileForm.get('organizations');
    for(let control of orgFormArray.controls) {
      let org_id = control.controls['org_id'].value;
      if(this.activeOrgs.length <= 1 && this.activeOrgs[0]['org_id'] == org_id) {
        control.controls['team_status'].disable()
      } else {
        control.controls['team_status'].enable()
      }
    }
  }

  changePassword() {
    this.dialog.open(ChangePasswordComponent, {
    });
  }
}
